const sectionsToRender = [
  {
    id: '#cart-counter',
    section: 'cart-counter',
    selector: '#shopify-section-cart-counter'
  },
  {
    id: '#CartDrawer-Body',
    section: 'cart-drawer',
    selector: '#shopify-section-cart-drawer #CartDrawer-Body'
  }
];

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this)
    );
    this.setCartLink();
    this.parentElement.addEventListener(
      'shopify:section:select',
      () => this.open()
    );
    this.parentElement.addEventListener(
      'shopify:section:deselect',
      () => this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    cartLink?.setAttribute('role', 'button');
    cartLink?.setAttribute('aria-haspopup', 'dialog');
    cartLink?.addEventListener('click', event => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink?.addEventListener('keydown', event => {
      if (event.code.toUpperCase() !== 'SPACE') return;
      event.preventDefault();
      this.open(cartLink);
    });
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    this.querySelector('.cart-drawer__inner').setAttribute('aria-hidden', 'false');

    this.addEventListener('transitionend', () => { if (this.classList.contains('is-visible')) this.focusOnCartDrawer(); }, {once:true});
    clearTimeout(this.focusTimer);
    this.focusTimer = setTimeout(() => { if (this.classList.contains('is-visible')) this.focusOnCartDrawer(); }, 400);

    document.body.classList.add('overflow-hidden');
  }

  close() {
    clearTimeout(this.focusTimer);
    this.classList.remove('is-visible');
    this.querySelector('.cart-drawer__inner').setAttribute('aria-hidden','true');
    removeTrapFocus(this.activeElement);

    const isHeaderMenuOpen = header?.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    document.body.classList.remove('overflow-hidden');

  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach(section => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement || !response.sections?.[section.section]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );
    });
    document.dispatchEvent(new CustomEvent('sn:cart-updated'));
    const error=document.getElementById('SnCartError');if(error)error.textContent='';
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  focusOnCartDrawer() {
    const cartDrawer = this.querySelector('.cart-drawer__inner');
    if (cartDrawer) {
      trapFocus(cartDrawer, cartDrawer.querySelector('[data-drawer-close]')); 
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

